import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCache } from '../context/CacheContext';

const PageTransition: React.FC = () => {
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  const { invalidate } = useCache();

  useEffect(() => {
    // When location changes, show the overlay
    setIsActive(true);
    
    // Hide the overlay after a shorter delay (300ms instead of 500ms)
    // This makes transitions feel snappier
    const timer = setTimeout(() => {
      setIsActive(false);
    }, 300);
    
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className={`page-transition-overlay ${isActive ? 'active' : ''}`}>
      {/* <div className="loading-spinner"></div> */}
    </div>
  );
};

export default PageTransition;